import * as types from '../actions/ScandphotosActionTypes';
import InitialState from './ScandphotosInitialState';

export default function photographerBookingReducer(
    state: any = InitialState,
    action: { type: string; result: any }
) {
    switch (action.type) {
        case types.SCANDPHOTOS_NEW_ORDER_SUCCESS:
            return {
                ...state,
                orderProperties: action.result
            };
        case types.SCANDPHOTOS_NEW_ORDER_FIRM_DETAILS_SUCCESS:
            return {
                ...state,
                newProducts: action.result.products,
                orderProperties: {
                    ...state.orderProperties,
                    brokerFirmRegionId: action.result.regionId
                }
            };

        default:
            return state;
    }
}

const getScandphotosCreateOrder = (state) => state.scandphotosCreateOrder;
export const getOrderProperties = (state) => getScandphotosCreateOrder(state).orderProperties;
export const getNewProducts = (state) => getScandphotosCreateOrder(state).newProducts;
